<template>
  <div class="bg-white rounded-xl shadow-lg p-6">
    <h2 class="text-xl font-bold text-gray-900 mb-4 flex items-center gap-2">
      <span>🏆</span>
      Top 20 Productos Más Vendidos
    </h2>

    <div class="space-y-3 max-h-[600px] overflow-y-auto">
      <div
        v-for="producto in ranking.top_20_mas_vendidos"
        :key="producto.producto_id"
        class="border rounded-lg p-4 hover:shadow-md transition-all"
        :class="{'bg-gradient-to-r from-yellow-50 to-yellow-100': producto.posicion <= 3}"
      >
        <div class="flex items-start gap-3">
          <!-- Posición y Medalla -->
          <div class="flex-shrink-0 text-center">
            <div class="text-3xl mb-1">{{ producto.medalla }}</div>
            <div class="text-sm font-semibold text-gray-600">#{{ producto.posicion }}</div>
          </div>

          <!-- Info del Producto -->
          <div class="flex-1 min-w-0">
            <h4 class="font-semibold text-gray-900 mb-2 line-clamp-2">{{ producto.nombre }}</h4>
            
            <div class="grid grid-cols-2 sm:grid-cols-4 gap-3 mb-3">
              <div>
                <p class="text-xs text-gray-600">Veces Vendido</p>
                <p class="text-lg font-bold text-blue-600">{{ producto.veces_vendido }}</p>
              </div>
              <div>
                <p class="text-xs text-gray-600">Unidades Totales</p>
                <p class="text-lg font-bold text-purple-600">{{ producto.unidades_totales.toFixed(1) }}</p>
              </div>
              <div>
                <p class="text-xs text-gray-600">Producidas</p>
                <p class="text-lg font-bold text-green-600">{{ producto.unidades_producidas.toFixed(1) }}</p>
              </div>
              <div>
                <p class="text-xs text-gray-600">Días Promedio</p>
                <p class="text-lg font-bold text-orange-600">{{ producto.promedio_dias_produccion }}</p>
              </div>
            </div>

            <!-- Barra de Tasa de Producción -->
            <div>
              <div class="flex justify-between items-center mb-1">
                <span class="text-xs text-gray-600">Tasa de Producción</span>
                <span class="text-xs font-semibold text-gray-900">{{ producto.tasa_produccion.toFixed(1) }}%</span>
              </div>
              <div class="w-full bg-gray-200 rounded-full h-2">
                <div 
                  :class="getTasaColor(producto.tasa_produccion)"
                  class="h-2 rounded-full transition-all duration-500"
                  :style="`width: ${producto.tasa_produccion}%`"
                ></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RankingProductos',
  props: {
    ranking: {
      type: Object,
      required: true
    }
  },
  methods: {
    getTasaColor(tasa) {
      if (tasa >= 90) return 'bg-gradient-to-r from-green-400 to-green-600';
      if (tasa >= 75) return 'bg-gradient-to-r from-blue-400 to-blue-600';
      if (tasa >= 60) return 'bg-gradient-to-r from-yellow-400 to-yellow-600';
      return 'bg-gradient-to-r from-red-400 to-red-600';
    }
  }
};
</script>
